import { Paper, Typography } from '@mui/material'
import Cookies from 'js-cookie';
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function AboutSingleTeacher({teacher}) {
    const {t} = useTranslation()
    const lang = Cookies.get("i18next") || "en";
    return (
        <Paper sx={{padding:"32px 24px",marginY:"30px"}}>
            <Typography sx={{fontSize:{md:"22px",xs:"20px"},marginBottom:"18px"}}>{t('aboutTeacher')}</Typography>
            <Typography sx={{fontSize:{md:"17px",xs:"12px"}}}>
            {lang==='en'?teacher?.descriptionEn:teacher?.descriptionAr}
            </Typography>
        </Paper>
    )
}
